"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueBaseAppLoading = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const components_1 = require("../../components");
// tslint:disable-next-line: no-var-requires
const Logo = require('../../../assets/logo.png');
const BlueBaseAppLoading = ({ progress, image }) => (react_1.default.createElement(components_1.WaitObserver, null,
    react_1.default.createElement(react_native_1.View, { style: { alignItems: 'center', flex: 1, justifyContent: 'center' } },
        react_1.default.createElement(react_native_1.Image, { source: image, style: { height: 100, width: 100, margin: 16 } }),
        react_1.default.createElement(react_native_1.View, { style: {
                backgroundColor: 'rgba(0,0,0,.03)',
                borderRadius: 8,
                flexDirection: 'row',
                justifyContent: 'center',
                margin: 8,
                padding: 8,
            } },
            react_1.default.createElement(react_native_1.ActivityIndicator, null),
            react_1.default.createElement(react_native_1.Text, { style: { paddingLeft: 8 } },
                "Loading",
                progress.progress ? `: ${progress.progress}%` : null)))));
exports.BlueBaseAppLoading = BlueBaseAppLoading;
exports.BlueBaseAppLoading.defaultProps = {
    image: Logo,
};
exports.BlueBaseAppLoading.displayName = 'BlueBaseAppLoading';
